/**
 * The approved report catalogue — the ad-hoc builder's single source of
 * truth for data levels, fields, operators and types (CR-SEQ-2026-025).
 */
import { useQuery } from "@tanstack/react-query";

import { CatalogLevel, getReportCatalog } from "@services/reportEngine";

export const useReportCatalog = () => {
  return useQuery<CatalogLevel[]>(["reportCatalog"], getReportCatalog, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
